<template lang="pug">
SspLayout(area="core")
  .row
    .col-md-12
      form#orgForm.panel.panel-default(role="form" @submit.prevent="save")
        .panel-body
          .form-horizontal
            .form-group
              label.col-sm-3.control-label Name
              .col-sm-6
                input.organization-name.form-control(v-model="organization.name" type="text" placeholder="Organization Name")
            .form-group
              label.col-sm-3.control-label Email
              .col-sm-6
                input.organization-email.form-control(v-model="organization.email" type="email" placeholder="Organization Email")
        .panel-footer
          .text-right
            SspActionButton(type="submit" :disabled="!isValid" :spinning="saving")
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import Util from '@/service/Util'

export default {
  data: () => ({
    saving: false,
    organization: {
      name: null,
      email: null
    }
  }),
  methods: {
    save() {
      this.saving = true
      Security.createOrganization({ organization: this.organization })
        .then(() => {
          miniToastr.success('Oragnization successfully created')
          document.getElementById('orgForm').reset()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      return this.organization.name && Util.validateEmail(this.organization.email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/organization/CreateOrganization.vue